
  <!--
 * 竖版
 * @LastEditTime: Tue Dec 17 2024 15:43:17 GMT+0800 (中国标准时间)
 -->
  <template>
  <div id="u_r_0N9I59" :class="[curLang]" class="u_r_0N9I59 route-m"  ><u_c_EPKV20></u_c_EPKV20><u_c_92PM131></u_c_92PM131><u_c_K1XQ135></u_c_K1XQ135><u_c_113F49></u_c_113F49><u_c_2DMU62></u_c_2DMU62><u_c_9LBP81></u_c_9LBP81><u_c_O87P194></u_c_O87P194><div id="u_c_RIM321"  :class="[`normal`,`u_c_RIM321`]" ></div></div>
  </template>
<script setup>
import {reactive,provide,inject,onMounted,watch,watchEffect,ref,computed,nextTick,readonly,toRaw,markRaw} from "vue";
import * as vueUse from "@vueuse/core";
import Router from "@/hooks/router.js";
import { useRoute } from 'vue-router';
import bridge from "@/utils/sdkBridge.js";
import Language from "@/hooks/language.js";
import * as request from "@/api/request";
import * as utils from "@/utils";
import * as _ from "lodash-es";
import u_c_EPKV20 from "@/components/u_c_EPKV20.vue";import u_c_92PM131 from "@/components/u_c_92PM131.vue";import u_c_K1XQ135 from "@/components/u_c_K1XQ135.vue";import u_c_113F49 from "@/components/u_c_113F49.vue";import u_c_2DMU62 from "@/components/u_c_2DMU62.vue";import u_c_9LBP81 from "@/components/u_c_9LBP81.vue";import u_c_O87P194 from "@/components/u_c_O87P194.vue"

    const { curLang, getLangTxt, langData } = Language();
    const compData = {};
    const ROUTER_DATA_LANG = {"zh-CN":{},"zh-TW":{},"en-US":{},"ja-JP":{},"ko-KR":{},"th-TH":{},"vi-VN":{},"de-DE":{},"fr-FR":{},"ru-RU":{},"es-ES":{},"pt-PT":{},"it-IT":{},"tr-TR":{},"pl-PL":{},"id-ID":{},"ar-SA":{},"default":{}};
    const routerData = reactive(ROUTER_DATA_LANG[curLang] || ROUTER_DATA_LANG['en-US']||{});
    provide("routerData", routerData);
    const pageData = inject("pageData", {});
    const router = Router();
    const route = useRoute();
    let pagePlatform = "global"

    // 自定义setup - 开始
    const init = inject('init', () => {});

if (window.innerWidth > window.innerHeight && router.hasRoute('index')) {
  let routerCount = router.router.getRoutes().length;
  if (routerCount < 3) {
    init();
  } else {
    router.gotoRouter('/');
  }
} else {
  init();
}

    // 自定义setup - 结束

  

</script>
<style lang="scss" scoped>

.zh-CN ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.zh-CN ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.zh-CN ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.zh-TW ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.zh-TW ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.zh-TW ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.en-US ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.en-US ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.en-US ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.ja-JP ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.ja-JP ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.ja-JP ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.ko-KR ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.ko-KR ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.ko-KR ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.th-TH ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.th-TH ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.th-TH ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.vi-VN ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.vi-VN ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.vi-VN ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.de-DE ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.de-DE ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.de-DE ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.fr-FR ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.fr-FR ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.fr-FR ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.ru-RU ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.ru-RU ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.ru-RU ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.es-ES ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.es-ES ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.es-ES ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.pt-PT ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.pt-PT ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.pt-PT ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.it-IT ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.it-IT ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.it-IT ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.tr-TR ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.tr-TR ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.tr-TR ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.pl-PL ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.pl-PL ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.pl-PL ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.id-ID ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.id-ID ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.id-ID ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.ar-SA ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.ar-SA ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.ar-SA ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.default ::v-deep(.normal .page-common-btn){
font-size:0.61rem;
color:#ffffff;
font-weight:bold;
text-decoration:none;
text-shadow:0 0 10px #000;

}

.default ::v-deep(.router .normal.page-lottery-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360604995.png);

}

.default ::v-deep(.router .normal.page-common-btn-bg){
background-image:url(https://gimages.37games.com/aws_s3/img?s=/platform/one_image/2023/01/16727360602353.png);

}
.btn-light:hover{
  filter:brightness(1.2);
  cursor: pointer;
}
html,body{
  height:auto !important;
  width:100%;
}

[dir=rtl] .rtl-trans{
  transform:scaleX(-1);
}

.swiper-button-disabled{
  display:none;
}
.u_c_RIM321.normal{
position:relative;
width:100%;
height:1.33rem;
background-color:#272a2c;

}

</style>
